import { Box, HStack, Skeleton, useBreakpointValue, VStack } from 'native-base';
import SummaryHeader from '../SummaryHeader';
import CenteredSubTitle from '../CenteredSubTitle';
import React from 'react';
const EscrowSkeleton = () => {
  const direction = useBreakpointValue({
    base: 'column',
    md: 'row',
    lg: 'row'
  });
  return /*#__PURE__*/React.createElement(VStack, {
    space: 6
  }, /*#__PURE__*/React.createElement(SummaryHeader, null), /*#__PURE__*/React.createElement(Skeleton.Text, {
    lines: 2
  }), /*#__PURE__*/React.createElement(Skeleton.Text, {
    lines: 2
  }), /*#__PURE__*/React.createElement(Skeleton.Text, {
    lines: 1,
    w: "1/4"
  }), [1, 2, 3, 4].map(each => /*#__PURE__*/React.createElement(HStack, {
    space: "2",
    key: each
  }, /*#__PURE__*/React.createElement(Skeleton, {
    size: "5",
    rounded: "full"
  }), /*#__PURE__*/React.createElement(Skeleton.Text, {
    lines: 2,
    flex: 1
  }))), /*#__PURE__*/React.createElement(CenteredSubTitle, {
    title: 'Escrow Analysis Overview'
  }), /*#__PURE__*/React.createElement(Box, {
    px: {
      base: 0,
      md: 0,
      lg: 18
    },
    flexDirection: direction,
    justifyContent: "space-around"
  }, direction === 'column' ? /*#__PURE__*/React.createElement(VStack, {
    space: "4",
    my: "6",
    mx: {
      base: 0,
      md: 0,
      lg: 0
    }
  }, /*#__PURE__*/React.createElement(Skeleton.Text, {
    lines: 1,
    w: "35%"
  }), /*#__PURE__*/React.createElement(Skeleton.Text, {
    lines: 3
  }), /*#__PURE__*/React.createElement(Skeleton.Text, {
    lines: 3
  }), /*#__PURE__*/React.createElement(Skeleton.Text, {
    lines: 3
  })) : /*#__PURE__*/React.createElement(VStack, {
    space: "4",
    flex: 1
  }, /*#__PURE__*/React.createElement(Skeleton.Text, {
    lines: 1,
    w: "35%"
  }), /*#__PURE__*/React.createElement(Skeleton.Text, {
    lines: 3
  }), /*#__PURE__*/React.createElement(Skeleton.Text, {
    lines: 3
  }), /*#__PURE__*/React.createElement(Skeleton.Text, {
    lines: 3
  })), /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    my: 6,
    mx: {
      base: 0,
      md: 12,
      lg: 0
    },
    maxW: {
      base: 'full',
      md: 'full',
      lg: '45%'
    }
  }, /*#__PURE__*/React.createElement(VStack, {
    flex: 1
  }, [1, 2, 3, 4, 5, 6].map(each => /*#__PURE__*/React.createElement(Skeleton, {
    key: each
  }))))), /*#__PURE__*/React.createElement(CenteredSubTitle, {
    title: 'Payment Options'
  }), /*#__PURE__*/React.createElement(Box, {
    flexDirection: direction,
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    w: "300",
    h: "200",
    m: 4
  }), /*#__PURE__*/React.createElement(Skeleton, {
    w: "300",
    h: "200",
    m: 4
  })));
};
export default EscrowSkeleton;
//# sourceMappingURL=index.js.map